<template>
  <section class="marketing-automation-form">

    <loading v-if="!hasLoaded"
             class="marketing-automation-form-loading" />

    <marketing-automation-form-steps v-else
                                     :initial-steps="steps"
                                     :automation-id="automation.id" />

  </section>
</template>

<script>
import Loading from "@/components/generic/Loading.vue";
import MarketingAutomationFormSteps from "@components/modules/marketing/automation/form/steps/MarketingAutomationFormSteps";

export default {
  components: {
    MarketingAutomationFormSteps,
    Loading,
  },

  props: {
    automation: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      steps: [],
      hasLoaded: false,
    };
  },

  created() {
    this.fetchSteps();
  },

  methods: {
    async fetchSteps() {
      const steps = await this.$api.marketing.automation.flow.steps({
        automationId: this.automation.id,
      });

      if (steps) {
        this.steps = this.formatStepToArray(steps);
      }

      this.hasLoaded = true;
    },
    formatStepToArray(steps, array = []) {
      array.push({
        ...steps,
        properties: JSON.parse(steps.properties),
      });

      if (steps.next) {
        return this.formatStepToArray(steps.next, array);
      }

      return array;
    },
  },
};
</script>

<style lang="scss" scoped>
.marketing-automation-form {
  padding-bottom: 50px;

  .marketing-automation-form-loading {
    margin: 30px auto;
    width: 30px;
    height: 30px;
  }
}
</style>
